angular.module('lsnBase.autocompleteOff', []);